import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		borderRadius: token('radius.large'),
		width: '100%',
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
});

interface CardContainerProps {
	children: React.ReactNode;
	onClick?: () => void;
	testId?: string;
}

export function CardContainer({ children, testId }: CardContainerProps): React.JSX.Element {
	return (
		<Box xcss={styles.root} backgroundColor={'elevation.surface.sunken'} testId={testId}>
			{children}
		</Box>
	);
}
